/** Pack listing status: 1 active, 0 inactive, 3 draft (quest/hunt packs). */
export function packStatusLabel(status) {
  const n = Number(status);
  if (n === 1) return "Active";
  if (n === 3) return "Draft";
  if (n === 0) return "Inactive";
  return "Deleted";
}

export function packStatusBadgeClass(status) {
  const n = Number(status);
  if (n === 1) return "bg-success";
  if (n === 3) return "bg-warning text-dark";
  return "bg-secondary";
}

export const PACK_STATUS_FILTER_OPTIONS = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
  { value: "3", label: "Draft" },
];

/** Item group list: 2 published, 1 unpublished, 0 draft */
export function itemGroupStatusLabel(status) {
  const n = Number(status);
  if (n === 2) return "Published";
  if (n === 1) return "Unpublished";
  if (n === 0) return "Draft";
  return "Unknown";
}

export function itemGroupStatusBadgeClass(status) {
  const n = Number(status);
  if (n === 2) return "bg-success";
  if (n === 1) return "bg-warning text-dark";
  if (n === 0) return "bg-secondary";
  return "bg-secondary";
}

export const ITEM_GROUP_STATUS_FILTER_OPTIONS = [
  { value: "", label: "All Status" },
  { value: "2", label: "Published" },
  { value: "1", label: "Unpublished" },
  { value: "0", label: "Draft" },
];
